// extracted by mini-css-extract-plugin
export default {"menu-button":"CopilotCodeLinesMenu-module__menu-button__zMqLOmq"};